app.controller('popupDeleteWithReasonController', ['$mdDialog', 'labels', 'item', 'userModel', 'message',
        function($mdDialog, labels, item, userModel, message) {
    var self = this;
    self.title = null;
    self.message = message;
    self.labels = [labels];
    self.yesText = 'T.UI.APPLICATION.DELETE';
    self.noText = 'T.UI.APPLICATION.CANCEL';
    self.item = item;
    self.item.deletionDate = new Date();
    self.user = userModel.currentUser;

    self.forms =  {
        deleteConfirm: null
    };

    self.ok = function () {
        self.item.deleted = true;
        self.forms.deleteConfirm.$setSubmitted();
        if (self.forms.deleteConfirm.$valid) {
            $mdDialog.hide(self.item);
        }
    };

    self.cancel = function () {
        delete self.item.deletionDate;
        $mdDialog.cancel();
    };
}]);